import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Scroll listener — switches nav to glass mode after 20px
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const goToSection = (id) => {
    closeMenu();
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <header className={`site-nav${scrolled ? " scrolled" : ""}${menuOpen ? " menu-open" : ""}`}>
      <div className="site-nav__inner">

        {/* Logo */}
        <Link to="/" className="site-nav__logo" onClick={closeMenu}>
          <img src="/logo-gky.png" alt="RTC GKY" />
        </Link>

        {/* Desktop links */}
        <nav className="site-nav__links">
          <button onClick={() => goToSection("home")}>Beranda</button>
          <button onClick={() => goToSection("book")}>Cara Booking</button>
        </nav>

        {/* CTA + Hamburger */}
        <div className="site-nav__actions">
          <Link to="/events" className="site-nav__cta" onClick={closeMenu}>
            Lihat Event
          </Link>
          <button
            className={`site-nav__hamburger${scrolled ? " scrolled" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "Tutup menu" : "Buka menu"}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {/* Mobile full-screen overlay */}
      <div className="site-nav__mobile" aria-hidden={!menuOpen}>
        <nav className="site-nav__mobile-links">
          <button onClick={() => goToSection("home")}>Beranda</button>
          <button onClick={() => goToSection("book")}>Cara Booking</button>
          <Link to="/events" className="site-nav__mobile-cta" onClick={closeMenu}>
            Lihat Event
          </Link>
        </nav>
      </div>
    </header>
  );
}
